import AssessmentList from "pages/PanelPage/components/AssessmentList/AssessmentList";

export default AssessmentList;
